const HERO_IMAGE =
  'https://public.readdy.ai/ai/img_res/edited_fd1dc1176da8d717b374fff985c39e31_522883ff.jpg';

export default function Hero() {
  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-foreground-950">
      {/* Background: clean facade photo, no lettering or logo on the wall. */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full min-w-[178vh] min-h-[56.25vw]">
          <img
            src={HERO_IMAGE}
            alt="Historische Backsteinfabrik der Lederwarenfabrik in Remagen-Kripp in Schwarzweiß"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-black/40" />
      </div>

      <div className="relative z-10 container mx-auto px-6 text-center text-white pt-56 md:pt-24">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Fulfillment mit
            <span className="block my-4">
              <span
                className="block w-16 h-16 md:w-24 md:h-24 mx-auto"
                style={{
                  backgroundColor: '#B80E10',
                  maskImage: `url('https://static.readdy.ai/image/2e9ecc346a2ca29966c0e167990e2bed/79499d1f5ec25a9869bbd3b528ad4633.svg')`,
                  WebkitMaskImage: `url('https://static.readdy.ai/image/2e9ecc346a2ca29966c0e167990e2bed/79499d1f5ec25a9869bbd3b528ad4633.svg')`,
                  maskSize: 'contain',
                  WebkitMaskSize: 'contain',
                  maskRepeat: 'no-repeat',
                  WebkitMaskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  WebkitMaskPosition: 'center',
                }}
              />
            </span>
            <span className="block">und Hand</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            In der historischen Lederwarenfabrik in Remagen-Kripp packen wir jedes Paket
            eigenhändig. Wie früher. Mit Sorgfalt. <strong>Handgepackt. Auch mit Liebe.</strong>
          </p>
        </div>
      </div>

      <div
        className="absolute bottom-8 left-0 right-0 z-10 flex justify-center animate-bounce cursor-pointer"
        onClick={scrollToServices}
      >
        <i className="ri-arrow-down-line text-white text-2xl drop-shadow-lg hover:scale-110 transition-transform"></i>
      </div>
    </section>
  );
}